import axios from 'axios';

function buildNotification(params) {
    var notification = {
      to: '/topics/'+String(params.topic),
      notification: {
        sound: "default",
        title: params.title,
        body: params.body,
        content_available: true,
        priority: "high"
      }
    };

    return notification;
  }

  function buildRequest(notification) {
    var request = {
      url: 'https://fcm.googleapis.com/fcm/send',
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: 'key=AAAABWHG-2c:APA91bF4u-_idy_1r9E6AwC8k_zaYw1ZI4NwCcpbV9PZllT1dq997mN94PqBPW5GPWxeJ1Djkj2rdUUCRb1Py8crm1PyvbSJJfUvwzqtm1BCyzUatA24OpQb-CCZ9joDojbHsJMTyFMB'
      },
      data: notification
    };
    return request;
  }

  async function sendNotification (params) {
    if(params.topic == null) return;
    
    var notification = await buildNotification({
      topic: params.topic,
      title: params.title,
      body: params.body
    });

    var request = await buildRequest(notification);

    return axios(request)
        .then(res => {
            return true
        })
        .catch(error => {
            return false
        });
  }


export  {
    sendNotification
}


// WEBPACK FOOTER //
// ./src/store/fcm.js